
export const cero_item = [
    {
        "cero_item_nombre" : "Pronunciamiento",
        "cero_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/DocsPagweb/ProtocoloCero.pdf"
    },

]

export const sesiones_item = [
    {
        "etica_item_nombre" : "1er Sesión",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/DocsPagweb/Protocolo/Sesion2023.pdf"
    },
    {
        "etica_item_nombre" : "2da Sesión",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/DocsPagweb/Protocolo/Sesion2022.pdf"
    },
    {
        "etica_item_nombre" : "3ra Sesión",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/DocsPagweb/Protocolo/Sesion2021.pdf"
    },
    {
        "etica_item_nombre" : "4ta Sesión",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/DocsPagweb/Protocolo/Sesion2020.pdf"
    },

]

